export const FETCH_INDUSTRY_ANALYTICS_REQUEST = 'FETCH_INDUSTRY_ANALYTICS_REQUEST';
export const FETCH_INDUSTRY_ANALYTICS_SUCCESS = 'FETCH_INDUSTRY_ANALYTICS_SUCCESS';
export const FETCH_INDUSTRY_ANALYTICS_FAILURE = 'FETCH_INDUSTRY_ANALYTICS_FAILURE';
export const CHECK_INDUSTRY_ANALYTICS = 'CHECK_INDUSTRY_ANALYTICS';